module.exports = {
  "country": "NL",
  "artist": "Anouk",
  "song": "Birds",
  "year": "2013",
  "place": "9",
  "spotify": "6uPVcR5TJzmTE0nFUWgNMz"
};